import { useAtomValue } from 'jotai';
import AnnualReviewComponent from '../../../components/annual-review/AnnualReview';
import { userAtom } from '../../../store/atom';

const AnnualReview = () => {
  const { selectedMentee, cycleId } = useAtomValue(userAtom);

  if (!selectedMentee) return <>No mentee selected</>;
  if (!cycleId) return <>No cycle selected</>;
  return (
    <AnnualReviewComponent
      selectedMentee={selectedMentee}
      cycleId={cycleId}
      type="mentor"
      cycleStatus={null}
    />
  );
};

export default AnnualReview;
